import { PROFILE_DETAILS } from "../constants/reduxConstants";

const initialState = {
  details: {},
};
export const profileDetailsReducer = (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case PROFILE_DETAILS:
      return {
        ...state,
        details: {
          ...payload,
        },
      };
    default:
      return state;
  }
};
